import React, { useState} from "react";
import Menu from "../../../components/layout/menu/index"
import error404 from "../../../assets/images/errorPages/error404.svg"
import ErrorPage from "../../../components/shared/errorPages";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/auth";

export default function Error404() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { token, loading } = useAuth();
  const navigate = useNavigate();
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  React.useEffect(() => {
    if (!loading && !token) {
      navigate("/", { replace: true });
    }
  }, [loading, token, navigate]);

  if (loading || !token) {
    return null;
  }
  
  return (
    <div>
        <Menu isPageError={true} isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
        <ErrorPage
        title="No encontrado"
        description="La dirección ingresada no corresponde a un contenido existente.
                    Por favor, regrese a la página anterior."
        errorImage={error404}
        onClick={() => window.history.back()}
        />
    </div>
  )
}